import { render, staticRenderFns } from "./labscribe.vue?vue&type=template&id=53b37419"
import script from "./labscribe.vue?vue&type=script&lang=js"
export * from "./labscribe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports